import { ExplorableItemType } from '../../models/ContentType';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { GrantLicenseModes } from './SyncActiveDirectoryGroupRequest';

export interface IGetGroupDetailsParams {
  id: string; // the group's id
}

export interface IGetGroupDetailsResult extends IResult {
  id: string; // group id
  name: string; // group name. "All Users" group is already localized by the backend.
  createdAt: string;
  updatedAt: string;
  domainType: string;
  domainName?: string;
  isAllUsersGroup: boolean;
  minimumSiteRole?: string; // Returned for all active directory groups (domainType === 'activeDirectory')
  grantLicenseMode?: GrantLicenseModes;
}

export class GetGroupDetailsRequest extends Request<IGetGroupDetailsParams, IGetGroupDetailsResult> {
  constructor(params: IGetGroupDetailsParams) {
    super('getGroup', params);
  }
}
